vm-link-overlay {
    display: block;
    position: relative;
}

vm-link-overlay [slot="link-overlay"] {
    position: absolute;
    inset: 0;
    z-index: 0;
}

vm-link-overlay a[href]:not([slot="link-overlay"]) {
    position: relative;
    z-index: 1;
}
